import React, { useContext, useEffect, useState } from "react";
import "./My_Account_Tabs.css";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Button } from "react-bootstrap";
// import OrderCard from "../common_components/order_card/OrderCard";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Personal_Info from "./personal_info/Personal_Info";
import OrderCard from "./my_orders/order_card/OrderCard";
import My_Wallet from "./my_wallet/My_Wallet";
import Permission_Pogout_Modal from "../../../Common_modal/Permission_Pogout_Modal/Permission_Pogout_Modal";
import { Context } from "../../../../utils/context";
import {
  getAllNotification,
  getNotificationCount,
  SeeNotification,
} from "../../../../utils/apis/myAccount/myAccount";
import { formatCustomDate } from "../../../../utils/common";

const My_Account_Tabs = () => {
  const { signin } = useContext(Context);

  const navigate = useNavigate();

  const location = useLocation();

  const [activeKey, setActiveKey] = useState("first"); // default tab

  useEffect(() => {
    if (location.state?.selectedTab) {
      setActiveKey(location.state.selectedTab);
    }
  }, [location.state]);

  const [modalShow, setModalShow] = useState(false);

  const [notification, setNotification] = useState();
  const getNotification = async () => {
    const res = await getAllNotification();
    if (res?.success) {
      setNotification(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getNotification();
  }, []);
  const { setCountNotification, countNotification } = useContext(Context);
  const postSeeNotification = async () => {
    const res = await SeeNotification();
    if (res?.success) {
      const res = await getNotificationCount();
      setCountNotification(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    if (activeKey === "third") {
      postSeeNotification();
    }
  }, [activeKey]);

  return (
    <section className="My_Orders My_Account_Tabs">
      <div className="container">
        <div className="action_tab_section">
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
          >
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <Nav variant="pills" className="">
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/img1.png"
                          }
                        />
                      </div>

                      <span className="tab_text">Personal Information</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="second" as={Link} to="/my-orders">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/img2.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Order</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="third">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Notifications</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      eventKey="fourth"
                      as={Link}
                      to="/wallet-transaction"
                    >
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/img4.png"
                          }
                        />
                      </div>
                      <span className="tab_text">My Wallet</span>
                    </Nav.Link>
                  </Nav.Item>

                  {signin && (
                    <Nav.Item className="logout_nav">
                      <Nav.Link
                        onClick={() => {
                          setModalShow(true);
                        }}
                      >
                        <div className="img_holder">
                          <img
                            className="tab_icon"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/my_order/logout.png"
                            }
                          />
                        </div>
                        <span className="tab_text">Logout</span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </div>

              <div className="col-lg-9 col-md-8">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Personal_Info />
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <div
                        className=""
                        onClick={() => {
                          navigate("/delivered-order");
                        }}
                      >
                        <OrderCard
                          title="ScanMart Grocery"
                          footer_text_color="#007C08"
                          img="/assets/images/profile/myaccount/img1.png"
                          orderId="Order ID #675843"
                          items="2 Items"
                          kwd="KWD: 200"
                          footer_text="Delivering in 10 mins"
                          date="27th Oct. | 03:28 pm"
                        />
                        <OrderCard
                          title="ScanMart Grocery"
                          footer_text_color="#007C08"
                          img="/assets/images/profile/myaccount/img1.png"
                          orderId="Order ID #675843"
                          items="2 Items"
                          kwd="KWD: 200"
                          footer_text="Delivering in 10 mins"
                          date="27th Oct. | 03:28 pm"
                        />
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                      <div
                        className=""
                        // onClick={() => {
                        //   navigate("/delivered-order");
                        // }}
                      >
                        {notification?.map((val) => (
                          <OrderCard
                            showViewDetails
                            title={val?.orders_detail?.product?.name}
                            footer_text_color="#E47101"
                            img="/assets/images/profile/myaccount/img1.png"
                            orderId={val?.orders_detail?.invoice_number}
                            items={val?.orders_detail?.quantity}
                            kwd={val?.orders_detail?.total_amount}
                            //   footer_text="Delivering in 10 mins"
                            date={formatCustomDate(
                              val?.orders_detail?.createdAt
                            )}
                          />
                        ))}
                        {/* <OrderCard
                          showViewDetails
                          title="ScanMart Grocery"
                          footer_text_color="#E47101"
                          img="/assets/images/profile/myaccount/img1.png"
                          orderId="Order ID #675843"
                          items="2 Items"
                          kwd="KWD: 200"
                          footer_text="Delivering in 10 mins"
                          date="27th Oct. | 03:28 pm"
                        /> */}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>

      <Permission_Pogout_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default My_Account_Tabs;
